import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ChevronRight, Target } from 'lucide-react';
import { CollapsibleSection, KPICard } from './IntelligenceUIComponents';

const InsightItem = ({ text }) => (
  <li className="flex items-start gap-2 text-sm text-foreground">
    <ChevronRight className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
    {text}
  </li>
);

export const ExecutiveSummarySection = ({ data }) => {
  const es = data?.executiveSummary;
  if (!es) return null;

  const insights = es.executiveInsights || [];
  
  return (
    <CollapsibleSection title="Executive Summary" icon={Target} defaultOpen={true} badge="Strategic Overview">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
        <KPICard label="Strategic Influence" value={es.strategicInfluenceScore} sublabel="0-100 Index" />
        <KPICard label="Stability Rating" value={es.institutionalStabilityRating} sublabel="Institutional Grade" />
        <KPICard label="Leadership Impact" value={es.leadershipImpactIndex} sublabel="Impact Index" />
        <KPICard label="Media Exposure" value={`${es.mediaExposureWeight}%`} sublabel="Federation Share" />
        <KPICard label="Tournament Multiplier" value={`${es.tournamentLeverageMultiplier}x`} sublabel="Visibility Amp." />
        <KPICard label="Contract Horizon" value={`${es.contractHorizonImpact.yearsRemaining}yr`} sublabel={`${es.contractHorizonImpact.renewalProbability}% renewal`} />
      </div>
      
      <div className="bg-primary/5 rounded-lg p-4 border border-primary/20">
        <h3 className="text-xs text-muted-foreground uppercase tracking-wider mb-3">Executive Insights</h3>
        <ul className="space-y-2">
          {insights.length > 0 && <InsightItem text={insights[0]} />}
          {insights.length > 1 && <InsightItem text={insights[1]} />}
          {insights.length > 2 && <InsightItem text={insights[2]} />}
          {insights.length > 3 && <InsightItem text={insights[3]} />}
          {insights.length > 4 && <InsightItem text={insights[4]} />}
        </ul>
      </div>
    </CollapsibleSection>
  );
};

export default ExecutiveSummarySection;
